
import { Card } from '@/components/ui/card';

interface OrderSummaryProps {
  checkoutData: {
    plan?: string;
    whatsappAccounts?: number;
    negotiationsIncluded?: number;
    extraNegotiationsPacks?: number;
    basePrice?: number;
    extraWhatsappCost?: number;
    extraNegotiationsCost?: number;
    totalPrice?: number;
  };
}

export default function OrderSummary({ checkoutData }: OrderSummaryProps) {
  return (
    <Card className="p-6 bg-muted/50 border sticky top-20">
      <h2 className="font-semibold text-brand-azul mb-4">Resumo do pedido</h2>
      
      <div className="space-y-3 mb-4">
        <div className="text-sm">
          <span className="font-medium">Plano {checkoutData?.plan}</span>
          <div className="text-brand-azul/60">
            {checkoutData?.whatsappAccounts} contas WhatsApp
          </div>
          <div className="text-brand-azul/60">
            {checkoutData?.negotiationsIncluded + (checkoutData?.extraNegotiationsPacks * 100)} negociações/mês
          </div>
        </div>
      </div>
      
      <div className="border-t pt-4 mb-4">
        <div className="flex justify-between mb-2 text-sm">
          <span>Subtotal</span>
          <span>R${checkoutData?.basePrice?.toFixed(2)}</span>
        </div>
        
        {checkoutData?.extraWhatsappCost && checkoutData?.extraWhatsappCost > 0 && (
          <div className="flex justify-between mb-2 text-sm">
            <span>Contas WhatsApp adicionais</span>
            <span>R${checkoutData?.extraWhatsappCost.toFixed(2)}</span>
          </div>
        )}
        
        {checkoutData?.extraNegotiationsCost && checkoutData?.extraNegotiationsCost > 0 && (
          <div className="flex justify-between mb-2 text-sm">
            <span>Pacotes de negociações adicionais</span>
            <span>R${checkoutData?.extraNegotiationsCost.toFixed(2)}</span>
          </div>
        )}
      </div>
      
      <div className="border-t pt-4">
        <div className="flex justify-between font-bold text-brand-azul">
          <span>Total mensal</span>
          <span>R${checkoutData?.totalPrice?.toFixed(2)}</span>
        </div>
        <div className="text-xs text-brand-azul/60 mt-1">Cobrado mensalmente</div>
      </div>
    </Card>
  );
}
